import React from 'react';

type PluginStepIconProps = {
  width?: string;
  height?: string;
  color?: string;
  style?: React.CSSProperties;
};

function PluginStepIcon({
  color = '#6267AC',
  width = '60',
  height = '60',
  style,
}: PluginStepIconProps) {
  return (
    <svg
      width={width}
      height={height}
      color={color}
      style={style}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.11072 4.70494H3.10352V1.81934H12.1807V10.8965H9.49551V6.08974C9.49551 5.32505 8.8754 4.70494 8.11072 4.70494ZM2.10352 1.20414V5.32014C2.10352 5.53254 2.27592 5.70494 2.48832 5.70494H8.11072C8.32312 5.70494 8.49551 5.87734 8.49551 6.08974V11.5117C8.49551 11.7241 8.66792 11.8965 8.88032 11.8965H12.7959C13.0083 11.8965 13.1807 11.7241 13.1807 11.5117V1.20414C13.1807 0.991736 13.0083 0.819336 12.7959 0.819336H2.48832C2.27592 0.819336 2.10352 0.991736 2.10352 1.20414ZM1.97363 12.1861V7.62207H6.53763V12.1861H1.97363ZM7.12283 6.62207H1.38843C1.15935 6.62207 0.973633 6.80778 0.973633 7.03687V12.7713C0.973633 13.0004 1.15935 13.1861 1.38843 13.1861H7.12283C7.35192 13.1861 7.53763 13.0004 7.53763 12.7713V7.03687C7.53763 6.80778 7.35192 6.62207 7.12283 6.62207ZM2.91016 9.90439C2.91016 9.76632 3.02208 9.65439 3.16016 9.65439H4.00595V8.80859C4.00595 8.67052 4.11788 8.55859 4.25595 8.55859C4.39402 8.55859 4.50595 8.67052 4.50595 8.80859V9.65439H5.35142C5.48949 9.65439 5.60142 9.76632 5.60142 9.90439C5.60142 10.0425 5.48949 10.1544 5.35142 10.1544H4.50595V11.0001C4.50595 11.1382 4.39402 11.2501 4.25595 11.2501C4.11788 11.2501 4.00595 11.1382 4.00595 11.0001V10.1544H3.16016C3.02208 10.1544 2.91016 10.0425 2.91016 9.90439Z'
        fill='url(#paint0_linear_5795_7166)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5795_7166'
          x1='13'
          y1='1'
          x2='0.500001'
          y2='14'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#F38122' />
          <stop offset='0.529891' stop-color='#CD6670' />
          <stop offset='1' stop-color='#6F66AB' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PluginStepIcon;
